<template>
  <el-container v-title data-title="食堂订单" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>食堂管理</el-breadcrumb-item>
                <el-breadcrumb-item>食堂订单</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.userRealName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="起始时间">
                  <el-date-picker
                    v-model="searchForm.orderDateFrom"
                    type="date"
                    placeholder="选择起始日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker
                    v-model="searchForm.orderDateTo"
                    type="date"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="货品类型">
                  <el-select v-model="searchForm.goodsType" placeholder="货品类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="菜品" value="1"></el-option>
                    <el-option label="商品" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getCanteenOrderList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="id" label="订单编号" width="310"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="100"></el-table-column>
          <el-table-column prop="weekMenuDescription" label="周菜单" width="90"></el-table-column>
          <el-table-column prop="userRealName" label="用户姓名" width="77"></el-table-column>
          <el-table-column prop="goodsTypeName" label="货品类型" width="77"></el-table-column>
          <el-table-column prop="orderDate" label="订单交易日期" width="110"></el-table-column>
          <el-table-column prop="partOfDayName" label="菜品时段" width="77"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="70"></el-table-column>
          <el-table-column prop="orderAmount" :formatter="yuanOfOrderAmountFormatter" label="订单总额" width="80"></el-table-column>
          <el-table-column prop="settleAmount" :formatter="yuanOfSettleAmountFormatter" label="核销总额" width="80"></el-table-column>
          <el-table-column prop="refundAmount" :formatter="yuanOfRefundAmountFormatter" label="退款总额" width="80"></el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status == '3' && scope.row.goodsType == '1'" type="text" @click="canteenOrderRefund(scope.row.id)">退款</el-button>
              <el-button v-if="scope.row.status == '2' && scope.row.goodsType == '1'" type="text" @click="canteenOrderCancel(scope.row.id)">取消</el-button>
              <el-button type="text" @click="getCanteenOrderDetailList(scope.row.id)">订单明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getCanteenOrderList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（订单明细） -->
      <el-dialog
        title="订单明细"
        :visible.sync="orderDetailListDialogVisible"
        width="1170px"
        :before-close="handleClose">
        <el-table v-loading="loading" :data="orderDetailList" border stripe>
          <el-table-column prop="id" label="订单明细编号" width="300"></el-table-column>
          <el-table-column prop="goodsTypeName" label="货品类型" width="77"></el-table-column>
          <el-table-column prop="orderDate" label="订单交易日期" width="108"></el-table-column>
          <el-table-column prop="partOfDayName" label="菜品时段" width="77"></el-table-column>
          <el-table-column prop="goodsName" label="货品名称" width="100"></el-table-column>
          <el-table-column prop="goodsPrice" :formatter="yuanOfGoodsPriceFormatter" label="货品售价" width="77"></el-table-column>
          <el-table-column prop="qty" label="货品数量" width="77"></el-table-column>
          <el-table-column prop="detailAmount" :formatter="yuanOfDetailAmountFormatter" label="明细总额" width="77"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="60"></el-table-column>
          <el-table-column label="操作" width="176">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.status == '2' && scope.row.goodsType == '2'" @click="canteenOrderDetailHandleManual(scope.row.id)">核销</el-button>
              <el-button type="text" v-if="scope.row.status == '2'" @click="canteenOrderDetailCancel(scope.row.id)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button @click="orderDetailListDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        goodsType: ''
      },
      orderDetailList: [],
      orderDetailListDialogVisible: false,
      currentOrderId: null
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getCanteenOrderlList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          filterCanteen: '1'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getCanteenOrderList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getCanteenOrderList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenOrder/list',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          userRealName: _this.searchForm.userRealName,
          goodsType: _this.searchForm.goodsType,
          orderDateFrom: _this.searchForm.orderDateFrom,
          orderDateTo: _this.searchForm.orderDateTo,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    getCanteenOrderDetailList (orderId) {
      this.orderDetailListDialogVisible = true
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/list',
        this.$qs.stringify({
          orderId: orderId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.orderDetailList = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
        _this.currentOrderId = orderId
      })
    },
    canteenOrderRefund (orderId) {
      let _this = this
      this.$confirm('确认要退款吗？', '提示', {
        confirmButtonText: '退款',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/canteenOrder/refund',
          this.$qs.stringify({
            orderId: orderId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.getCanteenOrderList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    canteenOrderCancel (orderId) {
      let _this = this
      this.$confirm('确认要取消吗？', '提示', {
        confirmButtonText: '取消订单',
        cancelButtonText: '取消操作',
        type: 'warning'
      }).then(() => {
        _this.loading = true
        this.$axios.post(this.GLOBAL.host + '/canteenOrder/cancel',
          this.$qs.stringify({
            orderId: orderId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.getCanteenOrderList()
            } else {
              this.$message.error(res.data.message)
            }
          }
          _this.loading = false
        })
      })
    },
    canteenOrderDetailHandleManual (orderDetailId) {
      let _this = this
      this.$confirm('确认要核销吗？', '提示', {
        confirmButtonText: '核销',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true
        this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/canteenOrderDetailHandleManual',
          this.$qs.stringify({
            orderDetailId: orderDetailId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.getCanteenOrderDetailList(_this.currentOrderId)
              _this.getCanteenOrderList()
            } else {
              this.$message.error(res.data.message)
            }
          }
          _this.loading = false
        })
      })
    },
    canteenOrderDetailCancel (orderDetailId) {
      let _this = this
      this.$confirm('确认要取消订单明细吗？', '提示', {
        confirmButtonText: '取消订单明细',
        cancelButtonText: '取消操作',
        type: 'warning'
      }).then(() => {
        _this.loading = true
        this.$axios.post(this.GLOBAL.host + '/canteenOrderDetail/canteenOrderDetailCancel',
          this.$qs.stringify({
            orderDetailId: orderDetailId
          })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              _this.getCanteenOrderDetailList(_this.currentOrderId)
              _this.getCanteenOrderList()
            } else {
              this.$message.error(res.data.message)
            }
          }
          _this.loading = false
        })
      })
    },
    yuanOfOrderAmountFormatter (row) {
      return this.fenToyuanFormat(row.orderAmount)
    },
    yuanOfSettleAmountFormatter (row) {
      return this.fenToyuanFormat(row.settleAmount)
    },
    yuanOfRefundAmountFormatter (row) {
      return this.fenToyuanFormat(row.refundAmount)
    },
    yuanOfGoodsPriceFormatter (row) {
      return this.fenToyuanFormat(row.goodsPrice)
    },
    yuanOfDetailAmountFormatter (row) {
      return this.fenToyuanFormat(row.detailAmount)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenOrder.vue